// extracted by mini-css-extract-plugin
export var active = "_6f-7";
export var container = "_6f-0";
export var evenWidth = "_6f-4";
export var large = "_6f-5";
export var outlet = "_6f-8";
export var slide = "_6f-2";
export var small = "_6f-6";
export var tab = "_6f-3";
export var tabs = "_6f-1";